<template>
    <v-btn
        variant="flat"
        rounded="circle"
        height="70"
        width="70"
        color="#001FA3"
        @click="scrollToTop"
        >
        <svg width="29" height="18" viewBox="0 0 29 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M26.3563 17.5354L28.9375 14.9396L14.5 0.516663L0.0625019 14.9542L2.64375 17.5354L14.5 5.67916L26.3563 17.5354Z" 
            fill="white"/>
        </svg>
    </v-btn>
</template>
<script>

export default{
    name: 'BtnUp',
    methods: {
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }
}

</script>